import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { id } from '@swimlane/ngx-charts';
import { HelperService } from "../helperService";

@Injectable({
  providedIn: 'root',
})
export class APICustomdashboardService {
  ApiURL: string = '';
  constructor(private http: HttpClient, private helperService: HelperService) {
    this.ApiURL = environment.CustomdashboardUrl + 'Dashboard/';
  }

  public getKPIs(
    roleId:number,
    countryId: number,
    initialDate:any,
    finalDate:any,
    specificId?:number
    ): Observable<any> {
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
      };
    const url =
    `${this.ApiURL}KPIs/${roleId}/${countryId}/${initialDate}/${finalDate}` +
    (specificId ? `/${specificId}` : '')
    return this.http.get(url,requestOptions)
  }

  public getCalendar(roleId: number, secondId: number, thirdId?: number): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
    };
    const url =
        `${this.ApiURL}mycalendary/${roleId}/${secondId}` +
        (thirdId ? `/${thirdId}` : '')
        return this.http.get(url,requestOptions)
  }

  public getDashboardFilters(
    roleId: number,
    countryId:number,
    specificId?: number
    ): Observable<any> {
      const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
      const requestOptions = {
          headers: headers,
      };
    const url = `${this.ApiURL}GetDashboardFilters/${roleId}/${countryId}` +
    (specificId ? `/${specificId}` : '')
    return this.http.get(url,requestOptions)
  }

  public getDashboardGraph(
    roleId: number,
    countryId: number,
    initialDate: string,
    finalDate: string,
    EspeficicId: number,
    firstId: number = 0,
    secondId: number = 0,
    thirdId: number = 0,
    fourthId: number = 0
  ): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
    const requestOptions = {
        headers: headers,
    };
    const url =
      `${this.ApiURL}Graph/${roleId}/${countryId}/${initialDate}/${finalDate}` +
       `/${EspeficicId}`+
       `/${firstId}`  +
      `/${secondId}` +
     `/${thirdId}` +
     `/${fourthId}`
    return this.http.get(url,requestOptions);
  }
  
} 
